export default __webpack_public_path__ + "static/media/fractalStatic.f9b341db.jpg";